import type { ThemeDefinition } from "./types";
import { PALETTE, GPU_CLEAR_SAND, GPU_SHALLOWS, GPU_CORAL, GPU_SAPPHIRE } from "./palette";

export const daylight: ThemeDefinition = {
  label: "Daylight",
  className: "theme-daylight",
  bg: PALETTE.sand,
  text: PALETTE.sapphire,
  textMuted: `color-mix(in srgb, ${PALETTE.sapphire} 60%, transparent)`,
  accent: PALETTE.coral,
  glassRgb: "230,204,178",
  border: "rgba(255,255,255,0.50)",
  borderHighlight: "rgba(255,255,255,0.50)",
  separator: `color-mix(in srgb, ${PALETTE.sapphire} 30%, transparent)`,
  selection: PALETTE.sapphire,
  selectionText: "#ffffff",
  gridColor: PALETTE.shallows,
  noiseOpacity: "0.03",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.4), 0 10px 0px rgba(3,8,16,0.18)",
  gpuClear: GPU_CLEAR_SAND,
  gpuGridLine: GPU_SHALLOWS,
  gpuGridAlpha: 0.7,
  gpuAxisX: GPU_CORAL,
  gpuAxisZ: GPU_SAPPHIRE,
  axisXColor: PALETTE.coral,
  axisZColor: PALETTE.sapphire,
  font: '"Space Grotesk", sans-serif',
};
